<template>
  <section>
    <b-modal
      id="modalWelcomeKits"
      centered
      hide-footer
      hide-header
      size="lg"
      hide-actions
      no-close-on-backdrop
    >
      <section class="">
        <div
          class="p-3 p-lg-4"
        >
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <span></span>
              <p v-if="isDownloading" class="mb-0">
                <b-spinner variant="primary" small></b-spinner>
                <span class="ms-2 w-sbold pri-alt">Descargando...</span>
              </p>
            </div>

            <button
              @click="closeModal()"
              class="c-link c-link--black d-flex align-items-center fs-21">
              <Icon icon="ep:close-bold" />
            </button>
          </div>
          <div class="c-slider">
            <div class="mb-3">
              <div id="slider-kits" class="swiper-container">
                <div class="swiper-wrapper">
                  <div
                    v-for="(kit, ikit) of welcomeKits"
                    :key="`welcome-kit-${kit.id}`"
                    class="swiper-slide">
                    <a
                      @click.prevent="downloadKit(kit, ikit)"
                      href="#"
                      class="d-block"
                      :class="{'opacity-50' : downloadedWelcomeKits.includes(kit.id)}"
                    >
                      <figure class="overflow-hidden br--medium">
                        <img
                          :src="kit.file_banner"
                          alt=""
                          class="w-100"
                        >
                      </figure>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div id="slider-kits-pagination" class="swiper-pagination"></div>
              </div>

              <div class="d-flex align-items-center">
                <button
                  id="slider-kits-prev"
                  class="c-button c-button--primary-ghost small"
                >
                  <div class="d-flex align-items-center">
                    <Icon icon="bi:arrow-left-short" class="fs-25" />
                    <span class="d-none d-md-inline-block">Anterior</span>
                  </div>
                </button>
                <button
                  id="slider-kits-next"
                  class="c-button c-button--primary-ghost small ms-2"
                >
                  <div class="d-flex align-items-center">
                    <span class="d-none d-md-inline-block">Siguiente</span>
                    <Icon icon="bi:arrow-right-short" class="fs-25" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </b-modal>
  </section>
</template>

<script>
import Swiper from 'swiper';

export default {
  data() {
    return {
      welcomeKits: [],
      downloadedWelcomeKits: [],
      sliderKits: null,

      isDownloading: false,
    };
  },
  props: ['user'],
  mounted() {
    this.getWelcomeKits();
  },
  methods: {
    initModal() {
      if (!window.localStorage.getItem('arcux_modal_welcome_kits')) {
        this.openModal();
      } else {
        const deadline = Number(window.localStorage.getItem('arcux_modal_welcome_kits'));
        const now = (new Date()).getTime() / 1000;

        if (now >= deadline) this.openModal();
      }
    },
    closeModal() {
      const deadline = ((new Date()).getTime() / 1000) + (12 * 3600);

      window.localStorage.setItem('arcux_modal_welcome_kits', String(deadline));

      this.$bvModal.hide('modalWelcomeKits');
    },
    openModal() {
      this.$bvModal.show('modalWelcomeKits');

      window.setTimeout(() => {
        this.sliderKits = new Swiper('#slider-kits', {
          slidesPerView: 1,
          spaceBetween: 10,
          speed: 2000,
          simulateTouch: false,

          pagination: {
            el: '#slider-kits-pagination',
            type: 'fraction',
          },

          navigation: {
            prevEl: '#slider-kits-prev',
            nextEl: '#slider-kits-next',
          },

          on: {
            init: () => {
              this.updateKitStatus(this.welcomeKits[0], 'seen');
            },
          },
        });

        this.sliderKits.on('transitionEnd', () => {
          this.updateKitStatus(this.welcomeKits[this.sliderKits.realIndex], 'seen');
        });
      }, 500);
    },

    getWelcomeKits() {
      const request = `${window.arcux.api}/users/${this.user.id}/welcome-kits`;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.initModal();

            this.welcomeKits = response.data;
          }
        })
        .catch(() => {

        });
    },
    downloadKit(kit, kitIndex) {
      const request = `${window.arcux.api}/users/${this.user.id}/welcome-kits/${kit.id}/download?file_path=${kit.file_path}`;

      this.isDownloading = true;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.blob();
          }

          throw res;
        })
        .then((response) => {
          window.setTimeout(() => {
            this.isDownloading = false;

            const blob = new Blob([response]);
            const link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);
            link.download = '🥳 Kit de Bienvenida - Arcux 🥳.zip';

            link.click();

            if (kitIndex < (this.welcomeKits.length - 1)) {
              this.sliderKits.slideNext();
            }

            this.markAsDownloaded(kit);
          }, 1000);
        })
        .catch(() => {});
    },
    markAsDownloaded(kit) {
      this.downloadedWelcomeKits.push(kit.id);

      this.updateKitStatus(kit, 'downloaded');
    },
    updateKitStatus(kit, newStatus) {
      const request = `${window.arcux.api}/users/${this.user.id}/welcome-kits/${kit.id}`;

      fetch(request, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({
          status: newStatus,
        }),
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then(() => { })
        .catch(() => {});
    },
  },
};
</script>
